import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        indexChannel: null, //导航栏首页信息
        columnList: [], //频道集合
        showPop: false, // 辟谣入口弹窗
        freshSearchFlag: false, // 刷新搜索结果标志
        loadingShow: false, // loading展示
        isShowWapHeader:true, // wap头部导航栏
        isShowWapFooter:true, // web Footer显示
        rightModuleId: {}, // 右侧模块id
        isRed:false, //飘红
        userInfo:JSON.parse(sessionStorage.getItem("userInfo") || "{}"),//用户信息
    },
    mutations: {
        setColumnList(state, data) {
            state.columnList = data
        },
        setIndexChannel(state, data) {
            state.indexChannel = data
        },
        setShowPop(state, flag) {
            state.showPop = flag
        },
        freshSearch(state, data) {
            state.freshSearchFlag = data
        },
        setLoadingShow(state, data) {
            state.loadingShow = data
        },
        setIsShowWapHeader(state,flag){
            state.isShowWapHeader = flag
        },
        setIsShowWapFooter(state,flag){
            state.isShowWapFooter = flag
        },
        setRightModuleId(state, data) {
            state.rightModuleId = data
        },
        setIsRed(state, data) {
            state.isRed = data
        },
        setUserInfo(state,data){
            state.userInfo = data;
            sessionStorage.setItem('userInfo',JSON.stringify(data))
        }
    }
})